// extracted by mini-css-extract-plugin
module.exports =  {"totalPremiumContainer":"PolicyVehiclesDriversInfo_totalPremiumContainer__BFda3","policyDriverContainer":"PolicyVehiclesDriversInfo_policyDriverContainer__2u2me"};